import { render, staticRenderFns } from "./CostBreakdownSecondaryTables.vue?vue&type=template&id=6cb05229&scoped=true&"
import script from "./CostBreakdownSecondaryTables.vue?vue&type=script&lang=js&"
export * from "./CostBreakdownSecondaryTables.vue?vue&type=script&lang=js&"
import style0 from "./CostBreakdownSecondaryTables.vue?vue&type=style&index=0&id=6cb05229&prod&scoped=true&lang=css&"
import style1 from "./CostBreakdownSecondaryTables.vue?vue&type=style&index=1&id=6cb05229&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb05229",
  null
  
)

export default component.exports